import api from "api"

export async function loadHouseholdEmployers(store, household_id) {
  const employers = await api.get(`households/${household_id}/employers`)
  await store.update(state => {
    state.householdEmployerIds[household_id] = employers.map(
      employer => employer.id
    )

    employers.forEach(employer => {
      state.employers[employer.id] = employer
    })
  })
}

export async function loadEmployer(store, employer_id) {
  const employer = await api.get(`employers/${employer_id}`)
  await store.update(state => {
    state.employers[employer.id] = employer
  })
}

export async function addEmployer(store, { household_id, ...employerDetails }) {
  const employer = await api.post(
    `households/${household_id}/employers`,
    undefined,
    employerDetails
  )

  await store.update(state => {
    if (!state.householdEmployerIds[household_id]) {
      state.householdEmployerIds[household_id] = []
    }
    state.householdEmployerIds[household_id].push(employer.id)
    state.employers[employer.id] = employer
  })
  return {
    employerId: employer.id
  }
}

export async function updateEmployer(store, { id, ...employerDetails }) {
  const employer = await api.patch(
    `employers/${id}`,
    undefined,
    employerDetails
  )

  await store.update(state => {
    state.employers[employer.id] = employer
  })
}

export async function deleteEmployer(store, { household_id, id }) {
  await api.delete(`employers/${id}`)
  await store.update(state => {
    state.householdEmployerIds[household_id].splice(
      state.householdEmployerIds[household_id].findIndex(
        employerId => employerId === id
      ),
      1
    )
  })
}

export async function searchEmployers(store, query) {
  const employers = await api.get("employers", {
    search: query,
    limit: 10
  })
  return { employers }
}

export async function searchForEmployerCustomers(store, query) {
  const employers = await api.get("auth/employers", {
    search: query,
    limit: 10
  })
  return { employers }
}

export async function getEmployerCustomer(store, employerId) {
  const employer = await api.get(`auth/employers/${employerId}`)
  return { employer }
}
